import React from 'react';
import VideoSpeedUpContext from '../VideoSpeedUpContext';

export default function VideoSpeedUpProvider(props) {
  const { children } = props;
  return <VideoSpeedUpContext.Provider>{children}</VideoSpeedUpContext.Provider>;
}
